import { render, staticRenderFns } from "./ARadioList.vue?vue&type=template&id=10b86d9a"
import script from "./ARadioList.vue?vue&type=script&lang=js"
export * from "./ARadioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports